class VideoProControl{
  constructor(videoDom_,progress_){
    this.videoDom = videoDom_;
    this.progressDom = progress_;
    this.progressLine = document.getElementById("progress");
    this.totalTime = 0 ;
    this.curTime= 0 ;
    this.totalWidth = 0;
    // console.log('123');
    this.init()
  }
  // 初始化
  init(){
    this.proDownX  = 0;
    this.ratio = 0;
    this.addEvents();
    this.resize();
    this.updateVideoTime();
  }
  resize(){
    this.totalWidth = this.progressDom.clientWidth;
    /*进度条宽度与视频长度比例尺*/
    this.ratio = this.totalTime / this.totalWidth;
  }
  // 添加事件监听
  addEvents(){
    this.videoDom.addEventListener('timeupdate',()=>{
      this.updateVideoTime();
    });
    this.videoDom.addEventListener('onload',()=>{
      this.updateVideoTime();
      this.resize();
    })
    this.videoDom.addEventListener('play',()=>{
      this.updateVideoTime();
      this.resize();
    })
    let proDom = this.progressDom;
    proDom.addEventListener('mousedown',(e)=>{
      this.proDownHandler(e);
    })
    proDom.addEventListener('mousemove',(e)=>{
      this.proMoveHandler(e);
    });
    /*全局监听鼠标抬起事件移除拖动*/
    window.addEventListener('mouseup',()=>{
      // 拖动状态取消
      this.proMove = false;
      // 如果鼠标抬起前 有按下事件代表该交互有效
      if(this.proDown){
        this.proDown = false;
        this.updateVideoProgress();
      }
    })
    window.addEventListener('resize',()=>{
      this.resize();
      this.updateProWidth();
    });
  }
  /*刷新视频播放进度*/
  updateVideoProgress(){
    let time = this.proMoveX*this.ratio;
    this.videoDom.currentTime = time;
  }

  /*刷新进度条宽度*/
  updateProWidth(){
    let showW = this.curTime / this.ratio;
    this.progressLine.style.width = showW+'px';
  }

  /* 鼠标按下记录当前位置*/
  proDownHandler(e){
    var that = this
    this.proDown = true;
    // 初始抬起位置与移动位置在同一个交互点
    this.proDownX  = e.offsetX;
    this.proMoveX  = e.offsetX;
    // that.coverTest(e.offsetX)
  }
  /*鼠标移动记录当前位置*/
  proMoveHandler(e){
    var that = this
    if(!this.proDown ) return;
    this.proMoveX = e.offsetX;
    this.progressLine.style.width = this.proMoveX+'px';
    // that.coverTest(e.offsetX)
  }
  /*更新视频时间进度*/
  updateVideoTime(){
    this.totalTime = this.videoDom.duration;
    this.curTime = this.videoDom.currentTime;
    /* 如果当前正在拖动中， 则不刷新进度条宽度*/
    if(this.proDown)return;
    this.updateProWidth();
  }
}
export {VideoProControl}



// WEBPACK FOOTER //
// ./src/webgl/control/VideoProControl.js